import React from 'react'
import { Box } from "@mui/material"
import { ButtonIconSeeker } from "@ui-seeker/core"
import { useGlobalBatchMultiple } from "Pages/Admin/GlobalExecution/Batches/@hooks"


export default function GlobalExecutionToolbarSelect({ selectedData, setSelectedRows }) {

	const { handleStopMultipleExecutions, handleRetryMultipleExecutions } = useGlobalBatchMultiple(selectedData, setSelectedRows)

	return <Box sx={{ mr: 2, display: 'flex', gap: 1 }}>
		<ButtonIconSeeker
			icon="circle-stop"
			iconWeight="light"
			tooltip="Stop multiple executions"
			onClick={handleStopMultipleExecutions}
		/>
		<ButtonIconSeeker
			icon="rotate-right"
			iconWeight="light"
			tooltip="Retry multiple executions"
			onClick={handleRetryMultipleExecutions}
		/>
	</Box>
}